import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import base from './modules/base.js'
import user from './modules/user.js'

const store = new Vuex.Store({
	modules:{
		base,
		user
	}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js